module.exports = __webpack_public_path__ + "static/img/job_1.4bf88015.png";